// @ts-nocheck
import React, {
    ChangeEvent,
    createRef,
    RefObject,
    useEffect,
    useRef,
    useState,
} from "react";
import styled from "../../theme";
import TrashIcon from "../../assets/icons/trash.svg";
import DownloadIcon from "../../assets/icons/download_icon.svg";
import MaximizeIcon from "../../assets/icons/maximize_icon.svg";
import DefaultImageTest from "../../assets/images/default_avatar.png";
import CloseIcon from "../../assets/icons/pop_up_close.svg";
import UploadNewIcon from "../../assets/icons/photograph_upload_icon.svg";
import { FiRotateCw } from "react-icons/fi";
import { Config } from "../../utils";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { trackView } from "../analytics/track_view";
import { MixpanelEvents } from "../analytics/mix_panel_events";
import { generatePresignedUrl } from "../../api/file-store";
import UploadErrorBanner from "../UI/upload-error-banner";

type UploadTabProps = {
    disabled: boolean;
    handleAddUploads?(uploads: any[], newUploads?: boolean): void;
    draperyOrderUploads: { id: number; items: any[] };
    orderType?: string | null | undefined
    accountId: number;
    isLoading: boolean | undefined;
    changeIsLoading: any;
};

const UploadContainer = styled.div`
    display: grid !important;
    grid-template-columns: repeat(3, minmax(200px, 1fr)) !important;
    column-gap: 28px !important;
    row-gap: 48px !important;
    padding-right: 20px !important;
    margin-top: 48px !important;
`;

const UploadBox = styled.div`
    border: 1px solid #e2e2e2 !important;
    box-shadow: 0 4px 16px 0px rgba(0, 0, 0, 0.12) !important;
    display: flex !important;
    flex-direction: column !important;
    position: relative !important;

    & .maximize_icon,
    & .close_icon {
        position: absolute !important;
        top: 4px !important;
        right: 4px !important;
        cursor: pointer !important;
    }

    & .close_icon {
        top: 10px !important;
        right: 10px !important;
        transform: scale(1.4) rotate(0deg) !important;
        transition: all 0.3s ease !important;

        &:hover {
            transform: scale(1.4) rotate(90deg) !important;
        }
    }

    &.maximized {
        height: 100% !important;
    }
`;

const UploadNewBox = styled.div<{
    dragActive?: boolean;
}>`
    border: 1px solid #e2e2e2 !important;
    box-shadow: 0 4px 16px 0px rgba(0, 0, 0, 0.12) !important;
    height: 413px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 12px !important;

    & .newUploadBox {
        user-select: none !important;
        display: flex !important;
        align-items: center !important;
        flex-direction: column !important;
        border: 2px dashed #d4d4d4 !important;
        border-radius: 12px !important;
        padding: 12px !important;
        text-align: center !important;
        background-color: ${(props) =>
            props.dragActive ? "#f0f0f0" : "white"} !important;
        width: 250px !important;
        min-height: 200px !important;
        max-height: 413px !important;

        & span {
            font-size: 14px !important;
        }

        & .from_computer {
            text-decoration: underline !important;
            color: ${({ theme }) => theme.colors.primary} !important;
            cursor: pointer !important;
            user-select: none !important;

            &.disabled {
                cursor: default !important;
                color: #d4d4d4 !important;
            }
        }

        & .cropper {
            margin-bottom: 12px !important;
            margin-top: 12px !important;

            &.noMargin {
                margin: 0 !important;
            }

            .cropper-container {
                background: #f2f2f2 !important;
            }
            .cropper-modal {
                background: #fff !important;
            }
            .rounded-image-select .cropper-view-box {
                border: 1px solid #00b2ff !important;
            }
            .cropper-point {
                color: inherit !important;
            }
        }
    }
`;

const UploadImagePreview = styled.div`
    background-color: #f6f6f6 !important;
    height: 229px !important;

    padding: 0px 28px !important;

    & img {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
        object-position: center !important;
    }

    & object,
    & iframe {
        width: 95% !important;
        height: 100%;
        border: none;
    }

    &.maximized {
        display: flex !important;
        justify-content: center !important;
        flex: 1.45 !important;

        & img {
            width: unset !important;
        }

        & object,
        & iframe {
            width: 100%;
            height: 100%;
        }
    }
`;

const UploadBoxContent = styled.div`
    height: 184px !important;
    padding: 12px !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 16px !important;
    background: white !important;

    &.maximized {
        height: 100% !important;
        flex: 1 !important;
    }
`;

const UploadBoxContentDesc = styled.div`
    height: 100% !important;

    & textarea {
        height: 100% !important;
        width: 100% !important;
        border: 1px solid #9d9d9d !important;
        border-radius: 4px !important;
        padding: 10px !important;
        outline: none !important;
        resize: none !important;

        &.readonly {
            cursor: default !important;
            background: white !important;
            border-color: #e2e2e2 !important;
        }

        &:disabled {
            background: white !important;
            border-color: #e2e2e2 !important;
        }
    }
`;

const UploadBoxAction = styled.div`
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    max-height: 24px !important;
    height: 100% !important;

    & > button {
        display: flex !important;
        align-items: center !important;
        gap: 6px !important;
        cursor: pointer !important;

        &.disabled {
            opacity: 0.5 !important;
            cursor: default !important;
        }

        & .actionName {
            color: #545454 !important;
            font-weight: 500 !important;
            font-size: 14px !important;
            line-height: normal !important;
        }
    }
`;

const UploadBoxMaximized = styled.div`
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) scale(0) !important;
    height: 80% !important;
    width: 80% !important;
    z-index: 1000 !important;
    opacity: 0 !important;
    transition: all 0.2s ease-out !important;

    &.active {
        opacity: 1 !important;
        transform: translate(-50%, -50%) scale(1) !important;
    }
`;

const UploadBoxMaximizedOverlay = styled.div`
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background: black !important;
    opacity: 0.4 !important;
    z-index: 999 !important;
    display: none !important;

    &.active {
        display: block !important;
    }
`;

const ALLOWED_IMAGE_EXTENSIONS = ["jpeg", "jpg", "png", "svg", "webp"];
const MAX_FILE_SIZE_KB = 10240;
const PDF_CONTENT_TYPE = "application/pdf";
const PDF_UPLOAD_ERROR_MESSAGE = "Failed to upload PDF. Please try again.";

const createPdfObjectUrlFromDataUri = (dataUri: string): string | null => {
    try {
        const base64Index = dataUri.indexOf("base64,");
        if (base64Index === -1) {
            return null;
        }
        const base64Data = dataUri.substring(base64Index + 7);
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });
        return URL.createObjectURL(blob);
    } catch (error) {
        console.error("Failed to create PDF object URL", error);
        return null;
    }
};

const isPdfUpload = (upload: any): boolean => {
    if (!upload) {
        return false;
    }

    const type = (upload.type || upload.mimeType || "").toLowerCase();
    const declaredType =
        typeof upload.fileType === "string"
            ? upload.fileType.toLowerCase()
            : "";
    const name = (upload.name || upload.originalName || "").toLowerCase();
    const sourceString =
        typeof upload.source === "string" ? upload.source : undefined;
    const normalizedSource = sourceString ? sourceString.toLowerCase() : "";
    const base64Segment = normalizedSource.includes("base64,")
        ? normalizedSource.split("base64,")[1]
        : "";
    const dataUriLooksPdf =
        !!sourceString &&
        (normalizedSource.startsWith("data:application/pdf") ||
            (normalizedSource.startsWith("data:application/octet-stream") &&
                !!base64Segment &&
                base64Segment.startsWith("jvber")));

    return (
        upload.isPdf === true ||
        type === "pdf" ||
        declaredType === "pdf" ||
        type === "application/pdf" ||
        type.endsWith("+pdf") ||
        dataUriLooksPdf ||
        (!!name && name.endsWith(".pdf")) ||
        (!!normalizedSource && normalizedSource.includes(".pdf"))
    );
};

export const duplicateUploadTab = (draperyOrderUpload: any) => {
    return {
        ...draperyOrderUpload,
    };
};

export const dataURItoBlob = (dataURI: string) => {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(",")[1]);

    // separate out the mime component
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    const ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    const blob = new Blob([ab], { type: mimeString });
    return blob;
};

const sanitizeFileName = (fileName: string): string => {
    if (!fileName) {
        return "upload.pdf";
    }
    return fileName.replace(/[^a-z0-9._() -]/gi, "_");
};

const buildRemotePdfFileName = (fileName: string): string => {
    const sanitized = sanitizeFileName(fileName || "upload.pdf");
    const parts = sanitized.split(".");
    const extension = parts.length > 1 ? parts.pop() || "pdf" : "pdf";
    const base = parts.join(".") || "upload";
    return `${base}.${extension}`;
};

const buildRemoteSourcePath = (remoteKey: string): string => {
    if (!remoteKey) {
        return "";
    }
    return remoteKey.startsWith("/") ? remoteKey : `/${remoteKey}`;
};

const UploadTab = (props: UploadTabProps) => {
    const { disabled, handleAddUploads, draperyOrderUploads, accountId } = props;
    const { items } = draperyOrderUploads;

    // file upload and manage upload states
    const [currentImageIndex, setCurrentImageIndex] = useState<number>(0);
    const [uploadError, setUploadError] = useState<string | null>(null);
    const [dragActive, setDragActive] = useState<boolean>(false);
    const [rotateImage, setRotateImage] = useState<number>(0);
    const [zoomImage, setZoomImage] = useState<number>(0);
    const [imageUploads, setImageUploads] = useState<any[]>([]);
    const pdfObjectUrlsRef = useRef<Record<string, string>>({});
    const [pdfObjectUrls, setPdfObjectUrls] = useState<Record<string, string>>(
        {}
    );
    // refs
    const cropperRef: RefObject<any> = createRef();
    // maximize upload
    const [maximized, setMaximized] = useState<boolean>(false);
    // set upload for maximization
    const [upload, setUpload] = useState<any | null>(null);

    useEffect(() => {
        setUploadError(null);
    }, [disabled]);

    useEffect(() => {
        const prevMap = pdfObjectUrlsRef.current;
        const nextMap: Record<string, string> = {};

        if (items && items.length > 0) {
            items.forEach((item: any) => {
                if (!isPdfUpload(item) || item.fromRest) {
                    return;
                }
                const source = item.source;
                if (typeof source !== "string") {
                    return;
                }
                if (!source.startsWith("data:")) {
                    return;
                }
                if (prevMap[source]) {
                    nextMap[source] = prevMap[source];
                    return;
                }
                const objectUrl = createPdfObjectUrlFromDataUri(source);
                if (objectUrl) {
                    nextMap[source] = objectUrl;
                }
            });
        }

        Object.keys(prevMap).forEach((key) => {
            if (!nextMap[key]) {
                URL.revokeObjectURL(prevMap[key]);
            }
        });

        pdfObjectUrlsRef.current = nextMap;

        let changed =
            Object.keys(prevMap).length !== Object.keys(nextMap).length;
        if (!changed) {
            for (const key of Object.keys(nextMap)) {
                if (prevMap[key] !== nextMap[key]) {
                    changed = true;
                    break;
                }
            }
        }

        if (changed) {
            setPdfObjectUrls(nextMap);
        }
    }, [items]);

    useEffect(() => {
        return () => {
            const current = pdfObjectUrlsRef.current;
            Object.keys(current).forEach((key) => {
                try {
                    URL.revokeObjectURL(current[key]);
                } catch (error) {
                    console.warn("Failed to revoke object URL", error);
                }
            });
            pdfObjectUrlsRef.current = {};
        };
    }, []);

    const uploadPdfWithPresign = async (file: File) => {
        const storeId = `${accountId}_pdfs`;
        const generatedFileName = buildRemotePdfFileName(file.name || "upload.pdf");
        const contentType = file.type || PDF_CONTENT_TYPE;

        props.changeIsLoading(true)

        const presignResponse = await generatePresignedUrl({
            storeId,
            fileName: generatedFileName,
            method: "PUT",
            contentType,
            preserveFileName: true,
        });
        const resolvedFileName = presignResponse.fileName || generatedFileName;

        const response = await fetch(presignResponse.url, {
            method: presignResponse.method || "PUT",
            headers: {
                "Content-Type": contentType,
                "Content-Disposition": `attachment; filename="${resolvedFileName}"`,
            },
            body: file,
        });

        props.changeIsLoading(false)

        if (!response.ok) {
            throw new Error(
                `Failed to upload PDF via presigned URL. Status: ${response.status}`
            );
        }

        const remoteKey = presignResponse.key;
        return {
            remoteKey,
            remoteFileName: resolvedFileName,
            remoteSource: buildRemoteSourcePath(remoteKey),
        };
    };

    // download upload
    const handleDownloadUpload = async (u: any) => {
        try {
            const src = u.fromRest
                ? encodeURI(`${Config.fileStoreUrl}${u.source}`)
                : u.source;
            const response = await fetch(src);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = u.name;
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading image:", error);
        }
    };

    // delete upload
    const handleDeleteUpload = (item: any) => {
        if (disabled) {
            return;
        }

        if (items && items.length > 0) {
            const filteredArray = items.filter((_, i) => i !== item.index);
            if (handleAddUploads) {
                handleAddUploads(filteredArray, false);
            }
            handleCloseMaximized();
        }
    };

    // minimize image
    const handleCloseMaximized = () => {
        setMaximized(false);
        setUpload(null);
    };
    // maximize image
    const handleOpenMaximized = (item: any) => {
        setMaximized(true);
        setUpload(item);
    };
    // drag over upload
    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        setDragActive(true);
    };
    // drag leave upload
    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (disabled) return;
        setDragActive(false);
    };
    // drag and drop upload
    const handleDragDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();

        if (disabled) return;
        setDragActive(false);

        const files = e.dataTransfer.files;

        handleFile(files, 'drag_drop');
    };

    // trigger upload
    const handleChooseFile = () => {
        if (disabled) return;

        const inputEl = document.getElementById("fileInput");
        if (inputEl) {
            inputEl.click();
        }
    };

    // upload file or files
    const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files || [];

        handleFile(files, 'choose_from_computer');
    };

    const convertToPng = async (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                if (!ctx) {
                    reject("Canvas context is not supported.");
                    return;
                }

                canvas.width = image.width;
                canvas.height = image.height;

                ctx.drawImage(image, 0, 0);

                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            reject("Conversion to PNG failed.");
                            return;
                        }

                        const pngFile = new File(
                            [blob],
                            file.name.replace(/\.\w+$/, ".png")
                        );

                        const pngUrl = URL.createObjectURL(pngFile);

                        resolve(pngUrl);
                    },
                    "image/png",
                    1
                );
            };

            image.onerror = () => {
                reject("Image loading failed.");
            };

            image.src = URL.createObjectURL(file);
        });
    };

    const handleFile = async (files: File[] | FileList, element?: string) => {
        if (!files || files.length === 0) {
            return;
        }

        setUploadError(null);

        const pendingImageUploads: any[] = [];
        const directUploads: any[] = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileName = (file.name || "").toLowerCase();
            const extension = fileName.split(".").pop() || "";
            const mimeType = (file.type || "").toLowerCase();
            const isPdf = extension === "pdf" || mimeType === "application/pdf";
            const isImageExtension = ALLOWED_IMAGE_EXTENSIONS.some((ext) =>
                fileName.endsWith(ext)
            );

            if (!isPdf && !isImageExtension) {
                setUploadError(
                    "Valid file types: JPEG, PNG, SVG, WEBP, PDF."
                );
                trackView(MixpanelEvents.FILE_UPLOAD, {order_type: props.orderType, action_result: 'error', fe_error_text:"Valid file types: JPEG, PNG, SVG, WEBP, PDF.", file_type: extension, element})
                continue;
            }

            if (file.size / 1024 > MAX_FILE_SIZE_KB) {
                setUploadError("Max allowed size is 10MB.");
                trackView(MixpanelEvents.FILE_UPLOAD, {order_type: props.orderType, action_result: 'error', fe_error_text:"Max allowed size is 10MB.", file_type: extension, element})
                continue;
        }

        if (isPdf) {
            const upload: any = file;
            upload.source = URL.createObjectURL(file);
            upload.description = "";
            upload.fromRest = false;
            upload.isPdf = true;
            upload.blobToSend = file;
            upload.fileType = "pdf";
            upload.mimeType = file.type || PDF_CONTENT_TYPE;

            if (!Config.fileStoreUrl.includes("localhost")) {
                try {
                    const remoteInfo = await uploadPdfWithPresign(file);
                    upload.remoteKey = remoteInfo.remoteKey;
                    upload.remoteFileName = remoteInfo.remoteFileName;
                    upload.remoteSource = remoteInfo.remoteSource;
                    upload.remoteUploaded = true;
                } catch (error) {
                    console.error("Presigned PDF upload failed:", error);
                    setUploadError(PDF_UPLOAD_ERROR_MESSAGE);
                    continue;
                }
            }

            directUploads.push(upload);

            trackView(MixpanelEvents.FILE_UPLOAD, {order_type: props.orderType, action_result: 'success', file_type: extension , element})
            continue;
        }

        // payload for images
        let obj: any = {};

        if (
            fileName.endsWith(".svg") ||
            fileName.endsWith(".webp")
        ) {
            try {
                const pngUrl = await convertToPng(file);

                obj = file;
                obj.source = pngUrl;
                obj.description = "";
                obj.fromRest = false;
                obj.fileType = "image";
                obj.mimeType = file.type;

                trackView(MixpanelEvents.FILE_UPLOAD, {order_type: props.orderType, action_result: 'success', file_type: extension , element})

            } catch (error) {
                console.error(error);
            }
        } else {
            obj = file;
            obj.source = URL.createObjectURL(file);
            obj.description = "";
            obj.fromRest = false;
            obj.fileType = "image";
            obj.mimeType = file.type;

            trackView(MixpanelEvents.FILE_UPLOAD, {order_type: props.orderType, action_result: 'success', file_type: extension , element})
        }

        if (Object.keys(obj).length > 0) {
            pendingImageUploads.push(obj);
        }
        }

        if (directUploads.length > 0 && handleAddUploads) {
            handleAddUploads(directUploads, true);
        }

        setImageUploads(pendingImageUploads);
        setCurrentImageIndex(0);
        setRotateImage(0);
        setZoomImage(0);
    };

    // crop image change
    const handleCropChange = async () => {
        const currentUpload = imageUploads[currentImageIndex];

        if (!currentUpload || isPdfUpload(currentUpload)) {
            return true;
        }

        if (!cropperRef || !cropperRef.current || !cropperRef.current.cropper) {
            return true;
        }
        const croppedCanvas =
            await cropperRef.current.cropper.getCroppedCanvas();

        if (croppedCanvas) {
            const croppedImgData = await croppedCanvas.toDataURL();

            const originalBlob = await new Promise<Blob | null>((resolve) => {
                croppedCanvas.toBlob(
                    (blob: any) => resolve(blob),
                    'image/jpeg',
                    undefined
                );
            });

            if (!originalBlob) {
                console.error("Failed to create Blob from cropped image");
                return false;
            }

            if (croppedImgData) {
                setImageUploads((prev) => {
                    prev[currentImageIndex].source = croppedImgData;
                    prev[currentImageIndex].blobToSend = originalBlob;
                    return prev;
                });
                return true;
            }
        }

        return false;
    };

    // rotate image
    const handleRotateImage = () => {
        setRotateImage((prev) => {
            return prev + 1;
        });

        if (cropperRef && cropperRef.current && cropperRef.current.cropper) {
            cropperRef.current.cropper.rotate(90);
        }
    };

    // zoom image
    const changeZoom = (e: ChangeEvent<HTMLInputElement>) => {
        if (!cropperRef || !cropperRef.current || !cropperRef.current.cropper) {
            return;
        }

        const zoomValue = e.currentTarget.valueAsNumber;
        const zoomLevel = zoomValue / 100;

        setZoomImage(zoomValue);

        cropperRef.current.cropper.zoomTo(zoomLevel);
    };

    // go to next image
    const handleNextImage = async () => {
        if (
            imageUploads &&
            imageUploads.length &&
            imageUploads.length - 1 === currentImageIndex
        )
            return;
        setCurrentImageIndex((prev) => {
            return prev + 1;
        });
        await handleCropChange();
        setRotateImage(0);
    };

    const handleSaveUploads = async () => {
        if (await handleCropChange()) {
            // setUploads(prev => {
            //   return [
            //     ...prev,
            //     ...imageUploads
            //   ]
            // })
            if (handleAddUploads) {
                handleAddUploads(imageUploads, true);
            }
            setImageUploads([]);
            setUploadError(null);
            setCurrentImageIndex(0);
            setRotateImage(0);
            setZoomImage(0);
        }
    };

    const handleDeleteCurrentImage = () => {
        const filteredArray =
            imageUploads && imageUploads.length > 0
                ? imageUploads.filter((_, index) => index !== currentImageIndex)
                : [];
        setImageUploads(filteredArray);

        if (
            filteredArray &&
            filteredArray.length > 0 &&
            currentImageIndex !== 0
        ) {
            if (currentImageIndex >= filteredArray.length) {
                setCurrentImageIndex((prev) => prev - 1);
            }
        } else {
            setCurrentImageIndex(0);
        }
    };

    const handleChangeUploadDescription = (
        e: React.ChangeEvent<HTMLTextAreaElement>,
        index: number
    ) => {
        const updatedUploads = [...items];
        updatedUploads[index].description = e.target.value;
        if (handleAddUploads) {
            handleAddUploads(updatedUploads, false);
        }
    };

    const handleEnterPressed = (
        e: React.KeyboardEvent<HTMLTextAreaElement>
    ): void => {
        const key = e.key;
        if (key === "Enter" || key === "Return") {
            e.preventDefault();

            const textarea = e.currentTarget;
            const value = textarea.value;
            const selectionStart = textarea.selectionStart;
            const selectionEnd = textarea.selectionEnd;

            const part1 = value.slice(0, selectionStart);
            const part2 = value.slice(selectionEnd);

            const newValue = part1 + "\n" + part2;

            textarea.value = newValue;
            textarea.selectionStart = textarea.selectionEnd =
                selectionStart + 1;
        }
    };

    useEffect(() => {
        if (disabled) {
            setImageUploads([]);
        }
    }, [disabled]);

    const resolvePdfDisplayUrl = (
        uploadItem: any,
        fallbackUrl: string | null
    ) => {
        if (!uploadItem || !isPdfUpload(uploadItem)) {
            return fallbackUrl;
        }
        if (uploadItem.fromRest) {
            return fallbackUrl;
        }
        const source = uploadItem.source;
        if (typeof source === "string" && pdfObjectUrls[source]) {
            return pdfObjectUrls[source];
        }
        return fallbackUrl;
    };

    const maximizedUploadUrl =
        upload && upload.source
            ? upload.fromRest
                ? encodeURI(`${Config.fileStoreUrl}${upload.source}`)
                : upload.source
            : null;
    const isMaximizedUploadPdf = isPdfUpload(upload);
    const maximizedDisplayUrl = resolvePdfDisplayUrl(
        upload,
        maximizedUploadUrl
    );

    return (
        <UploadContainer>
            {items &&
                items.length > 0 &&
                items.map((u: any, idx) => {
                    const url = u.fromRest
                        ? encodeURI(`${Config.fileStoreUrl}${u.source}`)
                        : u.source;
                    const uploadModified = {
                        ...u,
                        index: idx,
                        name: u.name,
                    };
                    const isPdf = isPdfUpload(uploadModified);
                    const displayUrl = isPdf
                        ? resolvePdfDisplayUrl(uploadModified, url)
                        : url;
                    return (
                        <UploadBox key={idx}>
                            <MaximizeIcon
                                onClick={() =>
                                    handleOpenMaximized(uploadModified)
                                }
                                className="maximize_icon"
                            />

                            <UploadImagePreview>
                                {isPdf ? (
                                    displayUrl ? (
                                        <object
                                            aria-label="PDF preview"
                                            data={displayUrl}
                                            type="application/pdf"
                                        >
                                            PDF preview unavailable
                                        </object>
                                    ) : (
                                        <img
                                            draggable={false}
                                            src={DefaultImageTest}
                                        />
                                    )
                                ) : (
                                    <img
                                        draggable={false}
                                        src={url || DefaultImageTest}
                                    />
                                )}
                            </UploadImagePreview>

                            <UploadBoxContent>
                                <UploadBoxContentDesc>
                                    <textarea
                                        disabled={disabled}
                                        onKeyDown={handleEnterPressed}
                                        onChange={(e) =>
                                            handleChangeUploadDescription(
                                                e,
                                                idx
                                            )
                                        }
                                        value={u.description || ""}
                                    />
                                </UploadBoxContentDesc>

                                <UploadBoxAction>
                                    <button
                                        type="button"
                                        onClick={() => handleDownloadUpload(u)}
                                    >
                                        <DownloadIcon />
                                        <span className="actionName">
                                            Download
                                        </span>
                                    </button>

                                    <button
                                        className={disabled ? "disabled" : ""}
                                        disabled={disabled}
                                        type="button"
                                        onClick={() =>
                                            handleDeleteUpload(uploadModified)
                                        }
                                    >
                                        <TrashIcon
                                            style={{
                                                height: "24px",
                                                width: "24px",
                                            }}
                                        />
                                        <span className="actionName">
                                            Delete
                                        </span>
                                    </button>
                                </UploadBoxAction>
                            </UploadBoxContent>
                        </UploadBox>
                    );
                })}

            <UploadNewBox dragActive={dragActive}>
                <input
                    type="file"
                    id="fileInput"
                    accept="image/*,application/pdf"
                    multiple
                    style={{ display: "none" }}
                    onChange={(e) => handleChangeFile(e)}
                />

                <div
                    onDrop={handleDragDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    className="newUploadBox"
                >
                    <div
                        className={`cropper ${
                            imageUploads && imageUploads.length > 0
                                ? "noMargin"
                                : ""
                        }`}
                    >
                        {imageUploads && imageUploads.length > 0 ? (
                            <>
                                <Cropper
                                    ref={cropperRef}
                                    src={imageUploads[currentImageIndex].source}
                                    guides={false}
                                    viewMode={2}
                                    dragMode={"move"}
                                    className={"rounded-image-select"}
                                    minCropBoxWidth={undefined}
                                    minCropBoxHeight={undefined}
                                    toggleDragModeOnDblclick={false}
                                    style={{ width: "240px", height: "250px" }}
                                />
                            </>
                        ) : (
                            <UploadNewIcon />
                        )}
                    </div>

                    {imageUploads && imageUploads.length > 0 && (
                        <div
                            draggable={false}
                            style={{
                                pointerEvents: dragActive ? "none" : "all",
                                userSelect: "none",
                            }}
                        >
                            <button
                                type="button"
                                onClick={() => handleDeleteCurrentImage()}
                            >
                                Delete
                            </button>
                        </div>
                    )}

                    {imageUploads && imageUploads.length > 0 && (
                        <div
                            className="flex items-center"
                            style={{
                                pointerEvents: dragActive ? "none" : "all",
                                userSelect: "none",
                                gap: "6px",
                            }}
                            draggable={false}
                        >
                            <button
                                type="button"
                                onClick={() => handleRotateImage()}
                            >
                                <FiRotateCw
                                    style={{
                                        fontSize: "20px",
                                        transform: `rotate(${
                                            rotateImage * 90
                                        }deg)`,
                                        transition: "all .15s ease",
                                    }}
                                />
                            </button>
                            <input
                                min={0}
                                max={1000}
                                step={1}
                                value={zoomImage}
                                onChange={(e) => changeZoom(e)}
                                style={{
                                    pointerEvents: dragActive ? "none" : "all",
                                    userSelect: "none",
                                }}
                                type="range"
                            />
                            {imageUploads.length > 1 &&
                            imageUploads.length - 1 !== currentImageIndex ? (
                                <button
                                    onClick={() => handleNextImage()}
                                    type="button"
                                >
                                    <span
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "14px",
                                        }}
                                    >
                                        Next
                                    </span>
                                </button>
                            ) : (
                                <button
                                    onClick={() => handleSaveUploads()}
                                    type="button"
                                >
                                    <span
                                        style={{
                                            fontWeight: "500",
                                            fontSize: "14px",
                                        }}
                                    >
                                        Save
                                    </span>
                                </button>
                            )}
                        </div>
                    )}

                    <span
                        draggable={false}
                        style={{
                            marginBottom: "8px",
                            userSelect: "none",
                            pointerEvents: "none",
                            color: disabled ? "#d4d4d4" : "unset",
                        }}
                    >
                        Drag and drop file here or
                    </span>

                    <span
                        style={{
                            pointerEvents: dragActive ? "none" : "all",
                            userSelect: "none",
                        }}
                        draggable={false}
                        onClick={handleChooseFile}
                        className={`from_computer ${
                            disabled ? "disabled" : ""
                        }`}
                    >
                        Choose from computer
                    </span>

                    {uploadError && (
                        <div
                            draggable={false}
                            style={{
                                marginTop: "12px",
                                pointerEvents: "none",
                                userSelect: "none",
                                width: "100%",
                            }}
                        >
                            <UploadErrorBanner centered message={uploadError} />
                        </div>
                    )}
                </div>
            </UploadNewBox>

            <UploadBoxMaximized className={maximized ? "active" : ""}>
                <UploadBox className="maximized">
                    <CloseIcon
                        onClick={() => handleCloseMaximized()}
                        className="close_icon"
                    />

                    <UploadImagePreview className="maximized">
                        {upload &&
                            (isMaximizedUploadPdf ? (
                                maximizedDisplayUrl ? (
                                    <object
                                        aria-label="PDF preview"
                                        data={maximizedDisplayUrl}
                                        type="application/pdf"
                                    >
                                        PDF preview unavailable
                                    </object>
                                ) : (
                                    <img
                                        draggable={false}
                                        src={DefaultImageTest}
                                    />
                                )
                            ) : (
                                <img
                                    draggable={false}
                                    src={
                                        maximizedDisplayUrl || DefaultImageTest
                                    }
                                />
                            ))}
                    </UploadImagePreview>

                    <UploadBoxContent className="maximized">
                        <UploadBoxContentDesc>
                            <textarea
                                className="readonly"
                                readOnly
                                value={
                                    upload && upload.description
                                        ? upload.description
                                        : ""
                                }
                            />
                        </UploadBoxContentDesc>

                        <UploadBoxAction>
                            <button
                                type="button"
                                onClick={() => handleDownloadUpload(upload)}
                            >
                                <DownloadIcon />
                                <span className="actionName">Download</span>
                            </button>

                            <button
                                disabled={disabled}
                                className={disabled ? "disabled" : ""}
                                type="button"
                                onClick={() => handleDeleteUpload(upload)}
                            >
                                <TrashIcon
                                    style={{ height: "24px", width: "24px" }}
                                />
                                <span className="actionName">Delete</span>
                            </button>
                        </UploadBoxAction>
                    </UploadBoxContent>
                </UploadBox>
            </UploadBoxMaximized>

            <UploadBoxMaximizedOverlay
                onClick={() => handleCloseMaximized()}
                className={maximized ? "active" : ""}
            />
        </UploadContainer>
    );
};

export default UploadTab;
